import { render, staticRenderFns } from "./logo-list.vue?vue&type=template&id=5548c294&scoped=true&"
import script from "./logo-list.vue?vue&type=script&lang=js&"
export * from "./logo-list.vue?vue&type=script&lang=js&"
import style0 from "./logo-list.vue?vue&type=style&index=0&id=5548c294&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5548c294",
  null
  
)

export default component.exports